/**
 * An object mapping country codes to their country name strings.
 *
 * @type {Object<string, string>}
 * @readonly
 * @see Object.freeze
 */
export const CountryNamesByCode = Object.freeze({
  AF: 'Afghanistan',
  AX: 'Aland Islands',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia, Plurinational State of',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CV: 'Cape Verde',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CA: 'Canada',
  CG: 'Congo',
  CD: 'Congo, The Democratic Republic of the Congo',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: "Cote d'Ivoire",
  HR: 'Croatia',
  CU: 'Cuba',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FK: 'Falkland Islands (Malvinas)',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  VA: 'Holy See (Vatican City State)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran, Islamic Republic of Persian Gulf',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: "Korea, Democratic People's Republic of Korea",
  KR: 'Korea, Republic of South Korea',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: 'Laos',
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Macedonia',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia, Federated States of Micronesia',
  MD: 'Moldova',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  AN: 'Netherlands Antilles',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestinian Territory, Occupied',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RO: 'Romania',
  RU: 'Russia',
  RW: 'Rwanda',
  RE: 'Reunion',
  BL: 'Saint Barthelemy',
  SH: 'Saint Helena, Ascension and Tristan Da Cunha',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin',
  PM: 'Saint Pierre and Miquelon',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia and the South Sandwich Islands',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard and Jan Mayen',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania, United Republic of Tanzania',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela, Bolivarian Republic of Venezuela',
  VN: 'Vietnam',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  WF: 'Wallis and Futuna',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
});

/**
 * An object mapping phone country codes to ISO 3166-1 alpha-2 country codes
 *
 * @type {Object<string, string>}
 * @readonly
 */
export const PhoneCountryCodes = Object.freeze({
  '+1': 'US', // United States (also Canada, but US is primary)
  '+7': 'RU', // Russia
  '+20': 'EG', // Egypt
  '+27': 'ZA', // South Africa
  '+30': 'GR', // Greece
  '+31': 'NL', // Netherlands
  '+32': 'BE', // Belgium
  '+33': 'FR', // France
  '+34': 'ES', // Spain
  '+36': 'HU', // Hungary
  '+39': 'IT', // Italy
  '+40': 'RO', // Romania
  '+41': 'CH', // Switzerland
  '+43': 'AT', // Austria
  '+44': 'GB', // United Kingdom
  '+45': 'DK', // Denmark
  '+46': 'SE', // Sweden
  '+47': 'NO', // Norway
  '+48': 'PL', // Poland
  '+49': 'DE', // Germany
  '+51': 'PE', // Peru
  '+52': 'MX', // Mexico
  '+53': 'CU', // Cuba
  '+54': 'AR', // Argentina
  '+55': 'BR', // Brazil
  '+56': 'CL', // Chile
  '+57': 'CO', // Colombia
  '+58': 'VE', // Venezuela
  '+60': 'MY', // Malaysia
  '+61': 'AU', // Australia
  '+62': 'ID', // Indonesia
  '+63': 'PH', // Philippines
  '+64': 'NZ', // New Zealand
  '+65': 'SG', // Singapore
  '+66': 'TH', // Thailand
  '+81': 'JP', // Japan
  '+82': 'KR', // South Korea
  '+84': 'VN', // Vietnam
  '+86': 'CN', // China
  '+90': 'TR', // Turkey
  '+91': 'IN', // India
  '+92': 'PK', // Pakistan
  '+93': 'AF', // Afghanistan
  '+94': 'LK', // Sri Lanka
  '+95': 'MM', // Myanmar
  '+98': 'IR', // Iran
  '+212': 'MA', // Morocco
  '+213': 'DZ', // Algeria
  '+216': 'TN', // Tunisia
  '+218': 'LY', // Libya
  '+220': 'GM', // Gambia
  '+221': 'SN', // Senegal
  '+223': 'ML', // Mali
  '+224': 'GN', // Guinea
  '+225': 'CI', // Ivory Coast
  '+226': 'BF', // Burkina Faso
  '+227': 'NE', // Niger
  '+228': 'TG', // Togo
  '+229': 'BJ', // Benin
  '+230': 'MU', // Mauritius
  '+231': 'LR', // Liberia
  '+232': 'SL', // Sierra Leone
  '+233': 'GH', // Ghana
  '+234': 'NG', // Nigeria
  '+235': 'TD', // Chad
  '+236': 'CF', // Central African Republic
  '+237': 'CM', // Cameroon
  '+238': 'CV', // Cape Verde
  '+239': 'ST', // Sao Tome and Principe
  '+240': 'GQ', // Equatorial Guinea
  '+241': 'GA', // Gabon
  '+242': 'CG', // Congo
  '+243': 'CD', // Democratic Republic of the Congo
  '+244': 'AO', // Angola
  '+245': 'GW', // Guinea-Bissau
  '+248': 'SC', // Seychelles
  '+249': 'SD', // Sudan
  '+250': 'RW', // Rwanda
  '+251': 'ET', // Ethiopia
  '+252': 'SO', // Somalia
  '+253': 'DJ', // Djibouti
  '+254': 'KE', // Kenya
  '+255': 'TZ', // Tanzania
  '+256': 'UG', // Uganda
  '+257': 'BI', // Burundi
  '+258': 'MZ', // Mozambique
  '+260': 'ZM', // Zambia
  '+261': 'MG', // Madagascar
  '+262': 'RE', // Reunion
  '+263': 'ZW', // Zimbabwe
  '+264': 'NA', // Namibia
  '+265': 'MW', // Malawi
  '+266': 'LS', // Lesotho
  '+267': 'BW', // Botswana
  '+268': 'SZ', // Swaziland
  '+269': 'KM', // Comoros
  '+290': 'SH', // Saint Helena
  '+291': 'ER', // Eritrea
  '+297': 'AW', // Aruba
  '+298': 'FO', // Faroe Islands
  '+299': 'GL', // Greenland
  '+350': 'GI', // Gibraltar
  '+351': 'PT', // Portugal
  '+352': 'LU', // Luxembourg
  '+353': 'IE', // Ireland
  '+354': 'IS', // Iceland
  '+355': 'AL', // Albania
  '+356': 'MT', // Malta
  '+357': 'CY', // Cyprus
  '+358': 'FI', // Finland
  '+359': 'BG', // Bulgaria
  '+370': 'LT', // Lithuania
  '+371': 'LV', // Latvia
  '+372': 'EE', // Estonia
  '+373': 'MD', // Moldova
  '+374': 'AM', // Armenia
  '+375': 'BY', // Belarus
  '+376': 'AD', // Andorra
  '+377': 'MC', // Monaco
  '+378': 'SM', // San Marino
  '+380': 'UA', // Ukraine
  '+381': 'RS', // Serbia
  '+382': 'ME', // Montenegro
  '+383': 'XK', // Kosovo
  '+385': 'HR', // Croatia
  '+386': 'SI', // Slovenia
  '+387': 'BA', // Bosnia and Herzegovina
  '+389': 'MK', // North Macedonia
  '+420': 'CZ', // Czech Republic
  '+421': 'SK', // Slovakia
  '+423': 'LI', // Liechtenstein
  '+500': 'FK', // Falkland Islands
  '+501': 'BZ', // Belize
  '+502': 'GT', // Guatemala
  '+503': 'SV', // El Salvador
  '+504': 'HN', // Honduras
  '+505': 'NI', // Nicaragua
  '+506': 'CR', // Costa Rica
  '+507': 'PA', // Panama
  '+508': 'PM', // Saint Pierre and Miquelon
  '+509': 'HT', // Haiti
  '+590': 'GP', // Guadeloupe
  '+591': 'BO', // Bolivia
  '+592': 'GY', // Guyana
  '+593': 'EC', // Ecuador
  '+594': 'GF', // French Guiana
  '+595': 'PY', // Paraguay
  '+596': 'MQ', // Martinique
  '+597': 'SR', // Suriname
  '+598': 'UY', // Uruguay
  '+599': 'AN', // Netherlands Antilles
  '+670': 'TL', // Timor-Leste
  '+672': 'NF', // Norfolk Island
  '+673': 'BN', // Brunei
  '+674': 'NR', // Nauru
  '+675': 'PG', // Papua New Guinea
  '+676': 'TO', // Tonga
  '+677': 'SB', // Solomon Islands
  '+678': 'VU', // Vanuatu
  '+679': 'FJ', // Fiji
  '+680': 'PW', // Palau
  '+681': 'WF', // Wallis and Futuna
  '+682': 'CK', // Cook Islands
  '+683': 'NU', // Niue
  '+685': 'WS', // Samoa
  '+686': 'KI', // Kiribati
  '+687': 'NC', // New Caledonia
  '+688': 'TV', // Tuvalu
  '+689': 'PF', // French Polynesia
  '+690': 'TK', // Tokelau
  '+691': 'FM', // Micronesia
  '+692': 'MH', // Marshall Islands
  '+850': 'KP', // North Korea
  '+852': 'HK', // Hong Kong
  '+853': 'MO', // Macao
  '+855': 'KH', // Cambodia
  '+856': 'LA', // Laos
  '+880': 'BD', // Bangladesh
  '+886': 'TW', // Taiwan
  '+960': 'MV', // Maldives
  '+961': 'LB', // Lebanon
  '+962': 'JO', // Jordan
  '+963': 'SY', // Syria
  '+964': 'IQ', // Iraq
  '+965': 'KW', // Kuwait
  '+966': 'SA', // Saudi Arabia
  '+967': 'YE', // Yemen
  '+968': 'OM', // Oman
  '+970': 'PS', // Palestine
  '+971': 'AE', // United Arab Emirates
  '+972': 'IL', // Israel
  '+973': 'BH', // Bahrain
  '+974': 'QA', // Qatar
  '+975': 'BT', // Bhutan
  '+976': 'MN', // Mongolia
  '+977': 'NP', // Nepal
  '+992': 'TJ', // Tajikistan
  '+993': 'TM', // Turkmenistan
  '+994': 'AZ', // Azerbaijan
  '+995': 'GE', // Georgia
  '+996': 'KG', // Kyrgyzstan
  '+998': 'UZ', // Uzbekistan
});
